module.exports = "<label (click)=\"toggleText()\">\n  {{textValue}}\n</label>\n"